import { takeEvery, put, call } from "redux-saga/effects";
import { toast } from "react-toastify";

//Redux Actions
import CONSTANTS from "../CONSTANTS";
import KafkaService from "services/kafkaService";
import { actionSetKafkaList} from "../actions/kafkaActions";

function* sagaGetKafka({ page, limit, search }) {
    try {
      const result = yield call(KafkaService.getKafka, page, limit, search);
      if (result.status >= 400) {
        throw new Error('Get Kafka failed');
      }
      yield put(actionSetKafkaList(result.data.data));
    } catch (error) {
      toast.error(error.message || 'Get Kafka failed');
    }
}

export function* kafkaSaga() {
    yield takeEvery(CONSTANTS.KAFKA_GET_LIST, sagaGetKafka);
}
  